import axios from "axios";
import _ from "lodash";

export default ({ next, action, dispatch }) => {
    const { payload, type } = action;
    if (type === "PARTNERS:GET-PARTNER") {
        const promise = axios.get( `/portal/partners/associated-partner`);
        promise.then(
            r => dispatch({type: "PARTNERS:GET-PARTNER-SUCCESS", payload: { userPartner: _.get(r, 'data.partner', null) } }),
            e => dispatch({type: "PARTNERS:GET-PARTNER-ERROR"}));
    }
    if(type === "PARTNERS:ASSOCIATE-PARTNER") {
        const promise = axios.post( `/portal/partners/associate-partner`, { partner: payload.partner });
        promise.then(
            r => dispatch({ type: "PARTNERS:ASSOCIATE-PARTNER-SUCCESS", payload: { userPartner: payload.partner } }),
            e => dispatch({type: "PARTNERS:ASSOCIATE-PARTNER-ERROR", payload: { error: e }}));
    }
    return next(action);
};
